import React, { useEffect, useRef } from "react";

export const MouseEffect = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    
    const ctx = canvas.getContext("2d");
    let particlesArray = [];

    // Ekran boyutlarını ayarla
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;

    window.addEventListener("resize", () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    });

    const mouse = {
      x: undefined,
      y: undefined,
    };

    // Fare hareket ettiğinde parçacık oluştur
    window.addEventListener("mousemove", (event) => {
      mouse.x = event.x;
      mouse.y = event.y;
      // Her harekette 2 adet yeni daire fışkırsın
      particlesArray.push(new Particle());
    });

    // Parçacık (Daire) Sınıfı
    class Particle {
      constructor() {
        this.x = mouse.x;
        this.y = mouse.y;
        // Dairelerin rastgele büyüklüğü (1 ile 5 piksel arası)
        this.size = Math.random() * 4 + 1;
        // Rastgele dağılma hızları ve yönleri
        this.speedX = Math.random() * 1.5 - 0.75; // X yönündeki hızı düşürdük
        this.speedY = Math.random() * 1.5 - 0.75; // Y yönündeki hızı düşürdük
        // OmemTech Siber Mavi Rengi
        this.color = "#00e5ff";
      }
      
      update() {
        this.x += this.speedX;
        this.y += this.speedY;
        // Daireler zamanla küçülerek kaybolsun
        if (this.size > 0.2) this.size -= 0.05;
      }
      
      draw() {
        ctx.fillStyle = this.color;
        ctx.beginPath();
        ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2);
        ctx.fill();
      }
    }

    function handleParticles() {
      for (let i = 0; i < particlesArray.length; i++) {
        particlesArray[i].update();
        particlesArray[i].draw();
        
        // Çok küçülen daireleri hafızadan sil (Sitenin kasmasını önler)
        if (particlesArray[i].size <= 0.2) {
          particlesArray.splice(i, 1);
          i--;
        }
      }
    }

    function animate() {
      // Her karede eski çizimleri hafifçe silerek arkasında kuyruk (trail) bırakmasını sağla
      ctx.fillStyle = "rgba(255, 255, 255, 0.2)"; // Arka planın genel tonuna göre şeffaflık
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      
      handleParticles();
      requestAnimationFrame(animate);
    }
    
    animate();

  }, []);

  return (
    <canvas
      ref={canvasRef}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        pointerEvents: "none", // ÇOK ÖNEMLİ: Fare tıklamalarını engellemez, içinden geçer!
        zIndex: 9999, // Her şeyin en üstünde görünsün
      }}
    />
  );
};